import api from './api';
import { DashboardQueryParams, DashboardResponse } from '../types/dashboard';

export const dashboardService = {
    // GET /api/v1/site/dashboard?financialYear=2025-26&startDate=...&endDate=...
    getDashboard: async (params?: DashboardQueryParams): Promise<DashboardResponse> => {
        const response = await api.get('dashboard', { params });
        return response.data;
    },
};
